module.exports = __webpack_public_path__ + "media/packs/images/flags/UZ-e8901cfa8542b1fe0884a2adfb27b877.svg";